var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h4',[_c('span',{class:_vm.classes},[_vm._v("\n      "+_vm._s(_vm.parameters.text)+"\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }